import { PropsWithChildren, ReactNode } from 'react';
import { cn } from 'utils/cn';

export type LockedFeaturePreviewBlurIntensity = 'xs' | 'sm' | 'md' | 'lg';

export interface LockedFeaturePreviewProps extends PropsWithChildren {
  isLocked: boolean;
  message?: ReactNode;
  blurIntensity?: LockedFeaturePreviewBlurIntensity;
  className?: string;
  overlayClassName?: string;
  contentClassName?: string;
  messageClassName?: string;
}

const blurStyles: Record<LockedFeaturePreviewBlurIntensity, string> = {
  xs: 'backdrop-blur-xs',
  sm: 'backdrop-blur-sm',
  md: 'backdrop-blur',
  lg: 'backdrop-blur-lg'
};

const dimmedContentStyles: Record<LockedFeaturePreviewBlurIntensity, string> = {
  xs: 'opacity-90',
  sm: 'opacity-80',
  md: 'opacity-70',
  lg: 'opacity-60'
};

const LockedFeaturePreview = ({
  isLocked,
  message,
  blurIntensity = 'md',
  children,
  className,
  overlayClassName,
  contentClassName,
  messageClassName
}: LockedFeaturePreviewProps) => (
  <div className={cn('relative', className)}>
    {isLocked && (
      <>
        <div
          className={cn(
            'absolute inset-0 z-10 rounded-lg bg-white/5 dark:bg-gray-900/80',
            blurStyles[blurIntensity],
            overlayClassName
          )}
        />
        {message && (
          <div className='absolute inset-0 z-20 flex items-center justify-center text-center ~px-4/8'>
            <p
              className={cn(
                '~text-xs/sm font-medium text-gray-700 dark:text-gray-200 max-w-md',
                messageClassName
              )}>
              {message}
            </p>
          </div>
        )}
      </>
    )}

    <div
      className={cn(
        isLocked && 'pointer-events-none select-none',
        isLocked && dimmedContentStyles[blurIntensity],
        contentClassName
      )}>
      {children}
    </div>
  </div>
);

export default LockedFeaturePreview;
